import { createAction } from '@reduxjs/toolkit';
import { ITimesheetLock } from '../../../../dto';
import { ACT_SET, MN_TIMESHEET_LOCK, TYPE_LIST } from '../../../../common';

export const setTimesheetLocks = createAction<ITimesheetLock[]>(
  `${MN_TIMESHEET_LOCK}/${TYPE_LIST}/${ACT_SET}`,
);
